
export const esvSections = [
  {
    name: "ESV Bludenz - Sektion Kegeln",
    link: "https://esv-bludenz-kegeln.at/",
    icon: "images/sektion_kegeln.png",
  },
  {
    name: "ESV Bludenz - Sektion Schützen",
    link: "https://www.esv-schuetzen.at",
    icon: "images/sektion_schuetzen.png",
  },
  {
    name: "ESV Bludenz - Sektion Bergwandern",
    link: "/bergwandern", // Nur der Pfad,
    icon: "images/sektion_bergwandern.png",
  },
  {
    name: "Österreichischer Eisenbahnersport",
    link: "https://eisenbahnersport.at/",
    icon: "images/oees.png",
  },
  {
    name: "ASKÖ: Arbeitsgemeinschaft für Sport und Körperkultur in Österreich",
    link: "https://www.askoe-vorarlberg.at/de",
    icon: "images/askoe.jpg",
  },

];

